import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchLanguages } from '../redux/reducers/languages'
import { Loading } from 'tr-components/Loading'

class LanguageSupport extends Component {
  componentDidMount() {
    this.props.fetchLanguages()
  }

  render() {
    const { fetchedLanguages, children } = this.props

    if (!fetchedLanguages) return <Loading />

    return children
  }
}

const mapStateToProps = (state) => state.languages

const mapDispatchToProps = {
  fetchLanguages
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSupport)



// WEBPACK FOOTER //
// ./src/containers/LanguageSupport.js